










import { Component, Vue } from 'vue-property-decorator';
import { IItemProperty } from '@/store/types/ItemProperty';
import { State, Getter, Mutation } from 'vuex-class';
import Highlighter from '@/services/Highlighter.ts';
import ItemComponent from '../itemComponents/ItemComponent.vue';

@Component({
  components: {
    ItemComponent,
  },
})
export default class ItemList extends Vue {
  @State
  public isDisplayList!: boolean;
  @Getter
  public applyFilters!: IItemProperty[];
  @Getter
  public getMaxItems!: number;

  private highlighter!: Highlighter;

  constructor() {
    super();

    const element = document.getElementById('item-list-container') || document;
    this.highlighter = new Highlighter();
    element.onmousemove = this.highlighter.onmousemove.bind(this.highlighter);
  }
}
